import styled, { css } from 'styled-components';
import { EditCircle, ArrowDown } from '../utils/SvgIcons';

interface CheckboxContainerProps {
  shouldIndent?: boolean;
}

export const modalStyle = {
  filter: 'blur(2px)',
  overlay: {
    position: 'fixed' as any,
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 10000,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backdropFilter: 'blur(1px)',
    WebkitBackdropFilter: 'blur(1px)',
    backgroundColor: 'rgba(10, 32, 50, 0.8)',
  },
  content: {
    inset: 0,
    position: 'relative' as any,
    borderRadius: '2px',
    outline: 'none',
    maxHeight: '90vh',
    maxWidth: '600px',
    width: '100%',
    padding: '12px 0px 30px 20px',
    border: 'none',
    backgroundColor: '#E5E8E9',
  },
  outline: 'none',
};

interface RootContainerProps {
  gapSize?: number;
  noPadding?: boolean;
  noHorizontalPadding?: boolean;
}

const handlePadding = () => {
  return ({ noPadding, noHorizontalPadding }: RootContainerProps) => {
    if (noPadding) return '0px';
    if (noHorizontalPadding) return '20px 0px';
    return '20px';
  };
};

const handleGap = () => {
  return ({ gapSize }: RootContainerProps) => {
    if (gapSize) return `${gapSize}px`;
    return '14px';
  };
};

export const RootContainer = styled.section<RootContainerProps>`
  width: 100%;
  gap: ${handleGap};
  padding: ${handlePadding};
  background-color: ${(props) => props.theme.white};
  display: flex;
  flex-direction: column;
`;

export const TitleText = styled.h4`
  font-size: min(12px, 5vw);
  font-weight: bold;
  line-height: 12px;
  color: ${(props) => props.theme.blue};
`;

export const LightBlueText = styled.span`
  color: ${({ theme }) => theme.blue};
  font-size: 12px;
  font-weight: 400;
  ${({ lineHeight }) => lineHeight && `line-height: ${lineHeight};`}
`;

export const SmallText = styled.span`
  font-size: min(12px, 5vw);
  line-height: 18px;
  color: ${(props) => props.theme.darkblue};
`;

export const NoteText = styled.p`
  color: #7194ac;
  font-family: Heebo;
  font-size: min(10px, 4vw);
  line-height: 14px;
  text-align: center;
`;

export const Divider = styled.div`
  width: 100%;
  height: 1px;
  background-color: #dbe3ed;
`;

export const CheckboxContainer = styled.div<CheckboxContainerProps>`
  display: flex;
  gap: 8px;
  font-size: min(12px, 5vw);
  margin-left: ${({ shouldIndent }) => (shouldIndent ? '20px' : '0px')};

  input[type='checkbox'] {
    margin-left: 0;
  }

  label {
    white-space: wrap !important;
    transform: translateY(-1px);
  }
`;

export const NumberInput = styled.input.attrs({
  type: 'number',
  min: 0,
})`
  width: 70px;
  height: 30px;
  display: flex;
  text-align: center;
  align-items: center;
  justify-content: center;
  background-color: #e5e8e9 !important;
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
`;

export const RadioInput = styled.input.attrs({ type: 'radio' })`
  cursor: pointer;
  margin-right: 10px;
  accent-color: ${({ theme }) => theme.blue};
`;

export const SelectableBottomContainer = styled.div`
  padding: 8px 20px 20px 20px;
`;

export const ContentContainer = styled.div`
  width: 100%;
  padding: 0px 20px 0px 20px;
`;

export const TitleContainer = styled.div`
  padding: 20px 20px 0px 20px;
`;

export const StyledEditCircle = styled(EditCircle).attrs({
  className: 'w-20 h-20',
})`
  cursor: pointer;

  & path:nth-child(1) {
    transition: fill 0.3s ease-in-out;
    fill: ${({ fillColor }) => fillColor};
  }

  &:hover path:nth-child(1) {
    fill: ${({ theme }) => theme.darkblue};
  }
`;

export const transitionGroupClasses = css`
  transition: opacity 200ms ease-in, visibility 0s linear 200ms;
  opacity: 0;
  visibility: hidden;

  &.ease-enter-active,
  &.ease-enter-done {
    opacity: 1;
    visibility: visible;
    transition-delay: 0s;
  }

  &.ease-exit-active,
  &.ease-exit-done {
    opacity: 0;
    visibility: hidden;
    transition: opacity 200ms ease-in, visibility 0s linear 0s;
  }
`;

export const ArrowDownIcon = styled(ArrowDown)`
  transition: transform 0.2s ease-in-out;
  cursor: pointer;
  &.rotate {
    transform: rotate(-180deg);
  }
`;

export const ArrowUpIcon = styled(ArrowDownIcon)``;

interface TouchScrollableContainerProps {
  height?: string;
  marginBottom?: string;
}

export const TouchScrollableContainer = styled.div<TouchScrollableContainerProps>`
  overflow-y: auto;
  touch-action: pan-y;
  -webkit-overflow-scrolling: touch;
  ${({ height }) => height && `height: ${height};`}
  ${({ marginBottom }) => marginBottom && `margin-bottom: ${marginBottom};`}
`;
